'use strict';

var Promise = require('./core.js');

module.exports = Promise;
Promise.prototype.done = function (onFulfilled, onRejected) {
  var self = arguments.length ? this.then.apply(this, arguments) : this;
  self.then(null, function (err) {
    setTimeout(function () {
      throw err;
    }, 0);
  });
};



//////////////////
// WEBPACK FOOTER
// ./~/@dp/knb/~/promise/lib/done.js
// module id = 669
// module chunks = 0